import OrganizationArea from './organization-area-styles'

export default OrganizationArea
